import { Controller } from "stimulus"
import StimulusReflex from "stimulus_reflex";

const LOG_PREFIX = '[StripeController]';

export default class extends Controller {
  static targets = ["form", "card", "errors"]

  connect() {
    console.log(LOG_PREFIX, 'connect | initializing');
    StimulusReflex.register(this)
    this.stripe = Stripe(this.data.get("public-key"));

    const userId = this.data.get("user");
    console.log(LOG_PREFIX, 'connect | user:', userId, '| publicKey:', this.data.get("public-key")?.slice(0, 12) + '...');

    const hiddenUserInput = document.createElement("input");
    hiddenUserInput.setAttribute("type", "hidden");
    hiddenUserInput.setAttribute("name", "user");
    hiddenUserInput.setAttribute("value", userId);
    this.formTarget.appendChild(hiddenUserInput)
    let buttons = document.getElementsByClassName("stripe-add-card-button")
    buttons[buttons.length -1].disabled = true;
    const elements = this.stripe.elements();

    const style = {
      base: {
        color: '#333333',
        fontFamily: 'Roboto, Open Sans, Segoe UI, sans-serif',
        fontSmoothing: 'antialiased',
        fontSize: '16px',
        fontWeight: 'bold',
        '::placeholder': {
          color: '#333333'
        }
      },
      invalid: {
        color: '#fa755a',
        iconColor: '#fa755a'
      }
    };

    this.card = elements.create("card", { style: style });
    this.card.mount(this.cardTarget);
    let controller = this;
    this.card.addEventListener('change', function(event) {
      const displayError = controller.errorsTarget;
      let buttons = document.getElementsByClassName("stripe-add-card-button")
      if (event.error) {
        console.log(LOG_PREFIX, 'card change | validation error:', event.error.message);
        displayError.textContent = event.error.message;
        buttons[buttons.length -1].disabled = true;
      } else if (event.complete) {
        console.log(LOG_PREFIX, 'card change | card complete, ready to submit');
        displayError.textContent = "";
        buttons[buttons.length -1].disabled = false;
      } else {
        displayError.textContent = "";
        buttons[buttons.length -1].disabled = true;
      }
    });

    console.log(LOG_PREFIX, 'connect | card element mounted, ready');
  }

  change(event) {
    if (event.complete) {
      console.log(LOG_PREFIX, 'change | card input complete');
    }
    if (event.error) {
      console.log(LOG_PREFIX, 'change | error:', event.error.message);
      this.errorsTarget.textContent = event.error.message
      let buttons = document.getElementsByClassName("stripe-add-card-button")
      buttons[buttons.length -1].disabled = true;
    } else {
      this.errorsTarget.textContent = ""
    }
  }

  stripeTokenHandler(token) {
    console.log(LOG_PREFIX, 'stripeTokenHandler | token created:', token.id, '| card:', token.card?.brand, token.card?.last4);

    const hiddenInput = document.createElement("input")
    hiddenInput.setAttribute("type", "hidden")
    hiddenInput.setAttribute("name", "stripeToken")
    hiddenInput.setAttribute("value", token.id)
    this.formTarget.appendChild(hiddenInput)

    // Log the form data being sent to the reflex
    const formData = new FormData(this.formTarget);
    const params = {};
    for (const [key, value] of formData.entries()) {
      if (key === 'stripeToken') {
        params[key] = value.slice(0, 12) + '...';
      } else if (key !== 'authenticity_token') {
        params[key] = value;
      }
    }
    console.log(LOG_PREFIX, 'stripeTokenHandler | form params:', JSON.stringify(params));
    console.log(LOG_PREFIX, 'stripeTokenHandler | calling Stripe#create_payment_method reflex');

    this.card.update({ disabled: true });

    this.stimulate('Stripe#create_payment_method', { serializeForm: true }).then(() => {
      console.log(LOG_PREFIX, 'stripeTokenHandler | reflex SUCCESS, payment method created');
      document.body.classList.remove('wait');
    }).catch((error) => {
      console.error(LOG_PREFIX, 'stripeTokenHandler | reflex FAILED:', error);
      if (error && typeof error === 'object') {
        console.error(LOG_PREFIX, 'stripeTokenHandler | error details:', JSON.stringify(error, null, 2));
      }
      this.card.update({ disabled: false });
      let buttons = document.getElementsByClassName("stripe-add-card-button");
      if (buttons.length > 0) {
        buttons[buttons.length - 1].textContent = "Add Card";
        buttons[buttons.length - 1].disabled = false;
      }
      if (this.hasErrorsTarget) {
        this.errorsTarget.textContent = "Something went wrong. Please try again.";
      }
    })

  }

  submit(event) {
    event.preventDefault()
    console.log(LOG_PREFIX, 'submit | creating Stripe token...');
    let buttons = document.getElementsByClassName("stripe-add-card-button")
    buttons[buttons.length -1].textContent = "Adding Card..."
    buttons[buttons.length -1].disabled = true
    this.stripe.createToken(this.card).then((result) => {
      if (result.error) {
        console.error(LOG_PREFIX, 'submit | token creation failed:', result.error.message);
        this.errorsTarget.textContent = result.error.message
        buttons[buttons.length -1].disabled = true;
      } else {
        console.log(LOG_PREFIX, 'submit | token created successfully, proceeding to reflex');
        this.stripeTokenHandler(result.token)
      }
    })

  }

  usersubmit(event) {
    event.preventDefault()
    console.log(LOG_PREFIX, 'usersubmit | creating Stripe token...');

    this.stripe.createToken(this.card).then((result) => {
      if (result.error) {
        console.error(LOG_PREFIX, 'usersubmit | token creation failed:', result.error.message);
        this.errorsTarget.textContent = result.error.message
        let buttons = document.getElementsByClassName("stripe-add-card-button")
        buttons[buttons.length -1].disabled = true;
      } else {
        console.log(LOG_PREFIX, 'usersubmit | token created successfully, proceeding to reflex');
        this.stripeTokenHandler(result.token)
      }
    })

  }
}
